import http from './httpRequest.js'

class RtcGroupApi { }

// 客户列表
RtcGroupApi.prototype.visitorList = function (params) {
  return http({
    url: '/customer/ticket/visitorList',
    method: 'post',
    data: params
  })
}

// 申请导出
RtcGroupApi.prototype.apply = function (params) {
  return http({
    url: '/customer/ticket/apply',
    method: 'post',
    data: params
  })
}

// 历史记录
RtcGroupApi.prototype.history = function (params) {
  return http({
    url: '/customer/ticket/history',
    method: 'post',
    data: params
  })
}

// 历史记录
RtcGroupApi.prototype.info = function (ticketId) {
  return http({
    url: '/customer/ticket/info?ticketId=' + ticketId,
    method: 'post',
  })
}

// 历史记录
RtcGroupApi.prototype.export = function (ticketId) {
  return http({
    url: '/customer/ticket/export',
    method: 'post',
    params: {
      ticketId
    },
    responseType: 'blob'
  })
}

export default RtcGroupApi;